// Mobile horizontal scroll progress indicator — appends a thin track
// + thumb after any horizontally scrolling product carousel (featured
// collections, tabbed collections, etc.) so swipeable rows have a
// visible scroll position cue. Mobile-only.
//
// Self-injects styles to bypass any stale CSS asset cache.
(function setupScrollProgress() {
  if (window.__scrollProgressInited) return;
  window.__scrollProgressInited = true;

  // Inject styles
  var style = document.createElement('style');
  style.id = 'scroll-progress-styles';
  style.textContent = [
    '.scroll-progress-track { display: none; }',
    '@media screen and (max-width: 749px) {',
    '  .scroll-progress-track {',
    '    display: block;',
    '    position: relative;',
    '    height: 2px;',
    '    width: 30%;',
    '    max-width: 120px;',
    '    margin: 1.6rem auto 0;',
    '    background-color: rgba(var(--color-foreground), 0.15);',
    '    border-radius: 999px;',
    '    overflow: hidden;',
    '    pointer-events: none;',
    '  }',
    '  .scroll-progress-thumb {',
    '    position: absolute;',
    '    top: 0;',
    '    bottom: 0;',
    /* inset-inline-start: 0 → left:0 in LTR, right:0 in RTL — */
    /* fill grows from the leading edge in either direction. */
    '    inset-inline-start: 0;',
    '    height: 100%;',
    '    width: 0;',
    '    background-color: rgb(var(--color-foreground));',
    '    border-radius: 999px;',
    '    will-change: width;',
    '  }',
    '}',
    /* The track div is inserted between .slider-mobile-gutter and */
    /* .view-all, which breaks the theme's adjacent-sibling rule */
    /* `.slider-mobile-gutter + .view-all { margin-top: 3rem/5rem }` */
    /* (component-slider.css) — restore the same spacing here. Kept */
    /* outside the mobile media query: the track stays in the DOM */
    /* after a resize to desktop, still breaking the theme rule. */
    '.scroll-progress-track + .view-all { margin-top: 3rem; }',
    '@media screen and (min-width: 750px) {',
    '  .scroll-progress-track + .view-all { margin-top: 5rem; }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  var SELECTORS = '.slider-mobile-gutter, .product-grid.slider, .slider.slider--mobile, .slider.slider--tablet';
  var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };
  var isScrollable = function (el) { return el && el.scrollWidth > el.clientWidth + 2; };

  function attach(scrollable) {
    if (scrollable.dataset.spInit === '1') return;
    scrollable.dataset.spInit = '1';

    var track = document.createElement('div');
    // `ignore-empty` defeats the global `div:empty:not(.ignore-empty){display:none}`
    // rule applied site-wide — without it the empty thumb div gets hidden.
    track.className = 'scroll-progress-track ignore-empty';
    track.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('div');
    thumb.className = 'scroll-progress-thumb ignore-empty';
    track.appendChild(thumb);

    // Insert the track AFTER the outermost ancestor that also matches
    // SELECTORS (i.e. .slider-mobile-gutter wrapper) so the track sits
    // OUTSIDE any scroll container or bleed-margined wrapper. This keeps
    // its width consistent with the section's normal page-width gutter.
    var placement = scrollable;
    var p = scrollable.parentElement;
    while (p) {
      if (p.matches && p.matches(SELECTORS)) placement = p;
      p = p.parentElement;
    }
    if (placement.nextSibling) {
      placement.parentNode.insertBefore(track, placement.nextSibling);
    } else {
      placement.parentNode.appendChild(track);
    }

    var trackW = 0;

    function recalc() {
      var max = scrollable.scrollWidth - scrollable.clientWidth;
      if (max <= 0 || !isMobile()) {
        track.style.display = 'none';
        return;
      }
      track.style.display = '';
      trackW = track.clientWidth;
      update();
    }

    function update() {
      var max = scrollable.scrollWidth - scrollable.clientWidth;
      if (max <= 0) return;
      // Math.abs handles RTL where some browsers report scrollLeft as
      // negative (Chrome ≤84, Firefox legacy) or positive but inverted
      // direction (Safari). Normalizing to 0..1 progress works either way.
      var progress = Math.max(0, Math.min(1, Math.abs(scrollable.scrollLeft) / max));
      // Width grows from the leading edge (controlled by inset-inline-start
      // in CSS, which auto-flips to right in RTL).
      thumb.style.width = (progress * trackW) + 'px';
    }

    scrollable.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', recalc);
    requestAnimationFrame(recalc);
    setTimeout(recalc, 800);
  }

  function findAndAttach(root) {
    var all = (root || document).querySelectorAll(SELECTORS);
    var scrollables = [];
    all.forEach(function (el) {
      if (isScrollable(el)) scrollables.push(el);
    });
    // Dedupe nested matches: when both an outer wrapper (.slider-mobile-gutter)
    // and the inner list (.slider--mobile) are scrollable, only attach to the
    // innermost — that's the element the user's touch actually scrolls and
    // also avoids the visible duplicate "two stacked bars" bug.
    scrollables.forEach(function (el) {
      var hasInnerScrollable = false;
      for (var i = 0; i < scrollables.length; i++) {
        if (scrollables[i] !== el && el.contains(scrollables[i])) {
          hasInnerScrollable = true;
          break;
        }
      }
      if (!hasInnerScrollable) attach(el);
    });
  }

  function init() {
    if (!isMobile()) return;
    findAndAttach(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.tagName === 'DETAILS' && e.target.open && isMobile()) {
      setTimeout(function () { findAndAttach(e.target); }, 50);
    }
  }, true);
})();``